import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Dropdown, Modal, Row, Col } from "react-bootstrap";
import PerfectScrollbar from "perfect-scrollbar";
import coins from "utils/coins";
import socket from "utils/Socket";
import storage from "utils/Storage";
import { FaPlusMinus } from "react-icons/fa6";
import { BiChevronDown } from "react-icons/bi";

import { setCoin, gameCoin, setCredit } from "actions/gameCoin";
import { __, wait, decode, encode, forceSatoshiFormat, Event, getUID, sendNotfication, API } from 'utils/Helper';
import C from 'utils/Constant';
import styled from "styled-components";
// import {  } from "lucide-react";
import {
  Search,
  Wallet,
  ArrowDownUp,
  Vault,
  ChevronRight,
  WalletCards,
  X,
} from "lucide-react";
import Deposit from "components/User/Wallet/Deposit";
import DepositHello from "components/User/Wallet/Deposithello";
import WithdrawlHello from "components/User/Wallet/Withdrawhello";
import CoinSelectionModal from "components/CoinSelectionModal";
import SwapHello from "components/User/Wallet/SwapHello";
import Cookies from "js-cookie";
import { useTransactionsQuery, useTransferVaultLocalMutation, useGetVaultDataLocalMutation } from 'hooks/useWallet';
import { Link } from "react-router-dom";
import axios from "axios";
import DynamicDeposit from "pages/Payment/DynamicDeposit";
import DynamicWithdrawal from "pages/Withdrawal/DynamicWithdrawal";
import WalletModalHome from "components/User/Wallet/WalletModalHome";
import { padding } from "@mui/system";

const FALLBACK_CURRENCY_RATES = {
  USD: 1,
  INR: 100,
};

const CURRENCY_SYMBOLS = {
  USD: "$",
  INR: "₹ ",
};

const Container = styled.div`
  background-color: rgba(38, 44, 45, 0.9);
  display: flex;
  border-radius: 9px;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  padding: 0.32rem 0.4rem;
  border: 1px solid #3f494b;
  min-height: 40px;
  width: fit-content;
  max-width: 100%;

  @media (max-width: 620px) {
    width: fit-content;
    max-width: 100%;
    gap: 6px;
    padding: 0.3rem 0.36rem;
  }

  @media (max-width: 576px) {
    width: fit-content;
    max-width: 100%;
    border-radius: 9px;
    min-height: 38px;
  }

  @media (max-width: 450px) {
    width: fit-content;
    max-width: 100%;
  }

  @media (max-width: 381px) {
    width: fit-content;
    max-width: 100%;
    gap: 5px;
    padding: 0.24rem 0.28rem;
  }

  @media (max-width: 323px) {
    width: fit-content;
    max-width: 100%;
  }

  @media (max-width: 268px) {
    width: fit-content;
    max-width: 100%;
  }

  @media (max-width: 210px) {
    width: fit-content;
    max-width: 100%;
  }
`;

const Label = styled.div`
  display: block;
  margin-bottom: -5px;
  font-size: 14px;
  color: #373b40;
  font-family: normal;
`;

const CubBalance = styled.div`
  color: #99999;
  font-size: 14px;
  font-weight: bold;
  flex: 1;
  min-width: 0;
  margin: 0 2px 0 2px;

  @media (max-width: 576px) {
    margin: 0 2px 0 4px;
  }

  @media (max-width: 381px) {
    margin: 0 0 0 2px;
  }

  @media (max-width: 240px) {
    // margin-right: 0px !important;
    width: 60px;
  }

  @media (max-width: 210px) {
    width: 52px;
  }
`;
const WalletConatiner = styled.div`
  //   color: #99999;
  //   font-size: 14px;
  //   font-weight: bold;
  //   margin-right: 10px;
`;

const AmountLine = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.1;
  letter-spacing: 0;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;

  @media (max-width: 576px) {
    font-size: 13px;
  }

  @media (max-width: 381px) {
    font-size: 12px;
  }
`;

const ConversionLine = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.15;
  margin-top: 1px;
  color: #9fafb2;
  font-size: 9px;
  font-weight: 500;

  @media (max-width: 576px) {
    font-size: 9px;
    line-height: 1.1;
  }
`;

const CurrencyControl = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 70px;
  max-width: 74px;

  @media (max-width: 576px) {
    min-width: 64px;
    max-width: 68px;
  }

  @media (max-width: 381px) {
    min-width: 30px;
    max-width: 44px;
  }
`;

const CurrencySwitchButton = styled.button`
  background-color: #343b3d;
  color: #fff;
  border: 1px solid #4f5b5e;
  border-radius: 6px;
  height: 26px;
  font-size: 10px;
  font-weight: 700;
  padding: 0 6px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;

  &:hover {
    border-color: #5a686b;
  }

  &:focus {
    border-color: #24ee89;
    box-shadow: 0 0 0 1px rgba(36, 238, 137, 0.25);
  }

  @media (max-width: 576px) {
    height: 24px;
    font-size: 9px;
    padding: 0 4px;
  }

  @media (max-width: 381px) {
    height: 30px;
    font-size: 8px;
  }
`;

const WalletButton = styled.button`
  background-color: #7b61ff;
  border: none;
  border-radius: 0.5rem;
  color: rgb(0 0 0);
  font-size: 14px;
  font-weight: bold;
  padding: 10px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-image: linear-gradient(
    90deg,
    rgb(36, 238, 137),
    rgb(159, 232, 113)
  );
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px,
    rgb(29, 202, 106) 0px -2px inset;
  font-weight: 800;
  line-hieght: 1.6rem;

  div {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .wallet-text {
    font-size: 12px;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    div {
      gap: 3px;
    }

    .wallet-text {
      font-size: 10px;
    }
  }

  @media (max-width: 480px) {
    div {
      gap: 2px;
    }
  }
`;

const HeaderDepositButton = styled.button`
  padding: 6px 12px;
  border: none;
  color: #fff;
  height: 36px;
  display: flex;
  align-items: center;
  box-shadow: 0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset;
  background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
  border-radius: 5px;
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;

  @media (max-width: 576px) {
    padding: 6px 8px;
    font-size: 11px;
    height: 32px;
  }
`;
const ManageListButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  // background: #7438f7;
  border-radius: 30px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 700;
  color: #b3bec1;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  margin-bottom: 10px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  span {
    margin-right: 8px;
  }
`;
const Divider = styled.div`
  margin: 10px 0; /* Adds some spacing above and below */
`;
const SearchContainer = styled.div`
  // width: 100%;
  margin: 0px 15px;
  border: 1px solid #3a4142;
  border-radius: 1px solid black;
  display: flex;
  align-items: center;
  background-color: #2b2f30;
  border-radius: 10px;
  padding: 10px;

  input {
    border: none;
    background-color: transparent;
    font-size: 14px;
    color: #fff;
    flex: 1;
    padding-left: 8px;

    &::placeholder {
      color: #999;
    }
  }
`;

const ResponsiveModal = styled(Modal)`
  .modal-dialog {
    @media (min-width: 576px) {
      max-width: 90%;
      width: 400px;
    }
    @media (min-width: 768px) {
      max-width: 85%;
      width: 500px;
    }
    @media (min-width: 992px) {
      max-width: 80%;
      width: 600px;
    }
    @media (min-width: 1200px) {
      max-width: 400px;
      width: 100%;
    }
  }
`;

const ModalHeader = styled(Modal.Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  border-bottom: 1px solid #e9ecef;
`;

const ModalTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

const ModalSubtitle = styled.div`
  font-size: 14px;
  color: #616770;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  padding: 0.25rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
  opacity: 0.5;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
`;

const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #323738;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    /* For smaller mobile screens */
    gap: 0px;
  }
`;

const NavButton = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent !important;
  color: ${(props) => (props.active ? "#4caf50" : "#8c8c8c")};
  border: none;
  padding: 12px 20px;

  cursor: pointer;
  transition: border-bottom 0.3s, color 0.3s;
  font-size: clamp(10px 2vw, 14px) !important;
  gap: 8px;

  border-bottom: ${(props) => (props.active ? "2px solid #24EE89" : "none")};

  svg {
    margin-right: 8px;
  }

  @media (max-width: 400px) {
    padding: 12px 10px; /* Fixed colon issue */
  }
`;

const ContentArea = styled.div`
  background-color: #323738;
  margin: 18px;
  color: white;
  border-radius: 14px;
  padding: 12px 8px;
`;

const ContainerDeposit = styled.div`
  background-color: #2c2c2c;
  border-radius: 12px;
  padding: 16px;
  width: 100%;
  max-width: 400px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  color: #8c8c8c;
  font-size: 14px;
  margin-bottom: 12px;
`;

const CurrencyBox = styled.div`
  background-color: #292d2e;
  border: 1px solid #3a4142;
  border-radius: 8px;
  padding: 7px 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
`;

const CurrencyInfo = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

const CurrencyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-weight: bold;
  color: white;
`;

const CurrencyName = styled.span`
  font-size: clamp(10px, 3vw, 14px);
  font-weight: bold;
  color: white;
`;

const BalanceInfo = styled.div`
  text-align: right;
`;

const BalanceLabel = styled.div`
  font-size: 12px;
  color: #8c8c8c;
`;

const BalanceAmount = styled.div`
  font-size: clamp(9px, 3vw, 14px) !important;
  // white-space: nowrap;
  font-weight: bold;
  color: white;
`;

const ArrowIcon = styled.span`
  color: #8c8c8c;
  font-size: 18px;
`;

const InputContainer = styled.div`
  margin: 10px;
`;

const LabelSwap = styled.label`
  display: block;
  margin-bottom: 5px;
  fontWeight: "bold",
  font-size: 12px !important ;
  color: #b3bec1 !important;
  //   font-family:normal;
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  background-color: #292d2e;
  border: 1px solid #3a4142;
  border-radius: 10px;
  color: #ffffff;
  font-size: 12px;
`;

const ButtonGroup = styled.div`
  position: absolute;
  right: 3px;
  display: flex;
  align-items: center;
`;

const ButtonWithdrawl = styled.button`
  background-color: #32363f;
  border: none;
  color: #a0a0a0;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-right: 10px;

  &:hover {
    background-color: #3a3a3a;
  }
`;

const SubmitContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 0px;
`;

const FeeText = styled.div`
  color: #a0aec0;
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
`;

const GreenText = styled.span`
  color: #56cf16;
`;

const StyledButton = styled.button`
  background-image: linear-gradient(
    90deg,
    rgb(36, 238, 137),
    rgb(159, 232, 113)
  );
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px,
    rgb(29, 202, 106) 0px -2px inset;
  color: black;
  font-weight: bold;
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  width: 100%;
  max-width: 20rem;
  transition: all 0.3s ease-in-out;
  border: none;
`;
const ParentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const SwitcherContainer = styled.div`
  display: flex;
  background-color: #2b2e36;
  border-radius: 9999px;
  width: 256px;
  justify-content: center;
`;

const SwitcherButton = styled.div`
  flex: 1;
  padding: 8px 16px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  background-color: ${(props) => (props.active ? "#3C3F49" : "#2B2E36")};
  cursor: pointer;

  &:hover {
    background-color: #444854; /* Add a hover effect if needed */
  }
`;
// Styled components
const Container1 = styled.div`
  //   background-color: #1f2937;
  color: white;
  padding: 16px;
  border-radius: 12px;
  width: 100%;
`;

const HeaderButtonGroup = styled.div`
  display: flex;
  background-color: #292c32;
  border-radius: 50px;
  margin-bottom: 16px;
  width: 50%;
`;

const HeaderButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  border-radius: 50px;
  transition: all 0.3s ease;
  text-align: center;
  ${(props) =>
    props.active
      ? `
        background-color: #3B5432;
        color: white;
      `
      : `
        background-color: transparent;
        color: #9ca3af;
        &:hover {
          background-color: #3B5432;
          color: white;
        }
      `}
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  color: #9ca3af;
  font-size: 14px;
  margin-bottom: 16px;
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  font-size: 14px;
  color: white;
  margin-bottom: 12px;
`;
const StyledModal = styled(Modal)`
  .modal-content {
    background-color: #17181b;
    border-radius: 20px;
    border: none;
  }
  .modal-dialog {
    @media (min-width: 576px) {
      max-width: 90%;
      width: 400px;
    }
    @media (min-width: 768px) {
      max-width: 85%;
      width: 500px;
    }
    @media (min-width: 992px) {
      max-width: 80%;
      width: 600px;
    }
    @media (min-width: 1200px) {
      max-width: 75%;
      width: 800px;
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0 20px 20px;
  background-color: #17181b;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 0;
`;

const PlaceholderImage = styled.img`
  margin-bottom: 16px;
  width: 100px;
  height: 100px;
`;

const PlaceholderText = styled.p`
  color: #9ca3af;
`;

// Main ModalBody content
const ModalContent = () => {
  const [activeTab, setActiveTab] = useState("Deposit");

  const { data: transactionData = [], isLoading: loading, error: queryError } = useTransactionsQuery(activeTab, getUID);
  const error = queryError ? "Failed to fetch data." : null;
  const formatDateTime = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    return new Date(dateString).toLocaleDateString(undefined, options); // Format based on locale
  };
  // TanStack Query refetches automatically when activeTab changes

  return (
    <Container1>
      {/* Header Buttons */}
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <HeaderButtonGroup>
          <HeaderButton
            active={activeTab === "Deposit"}
            onClick={() => setActiveTab("Deposit")}
          >
            Deposit
          </HeaderButton>
          <HeaderButton
            active={activeTab === "Withdraw"}
            onClick={() => setActiveTab("Withdraw")}
          >
            Withdraw
          </HeaderButton>
        </HeaderButtonGroup>
      </div>

      {/* Content */}
      {loading ? (
        <EmptyState>
          <PlaceholderText>Loading data...</PlaceholderText>
        </EmptyState>
      ) : error ? (
        <EmptyState>
          <PlaceholderText>{error}</PlaceholderText>
        </EmptyState>
      ) : transactionData.length === 0 ? (
        <EmptyState>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
              width: "100%",
            }}
          >
            <img
              src="/assets/images/emptyPanda.webp"
              style={{ height: "400px", width: "200px", objectFit: "contain" }}
            />
            <PlaceholderText>No transactions available.</PlaceholderText>
          </div>
        </EmptyState>
      ) : (
        <>
          <div style={{ height: "300px" }}>
            {/* Table Header */}
            <TableHeader style={{ color: "#9ca3af" }}>
              <div>Date</div>
              <div>Amount</div>
              <div>Status</div>
              <div>
                {activeTab === "Deposit" ? "Transaction" : "Address"}
              </div>{" "}
              {/* For deposit it's orderid, for withdraw it's wallet */}
            </TableHeader>

            {/* Table Rows */}
            {transactionData.map((transaction, index) => (
              <TableRow style={{ color: "#9ca3af" }} key={index}>
                <div>
                  {activeTab === "Deposit"
                    ? formatDateTime(transaction.created_at)
                    : formatDateTime(transaction.date)}
                </div>{" "}
                {/* Time */}
                <div>{transaction.amount}</div> {/* Amount */}
                <div>{transaction.status}</div> {/* State */}
                <div>
                  {activeTab === "Deposit"
                    ? transaction.orderid
                    : transaction.wallet}
                </div>{" "}
                {/* Transaction */}
              </TableRow>
            ))}
          </div>
        </>
      )}
    </Container1>
  );
};

const CURRENCY_THEME = {
  USDT: { color: "#26a17b", glyph: "₮" },
  BTC: { color: "#f7931a", glyph: "₿" },
  ETH: { color: "#627eea", glyph: "Ξ" },
  LTC: { color: "#345d9d", glyph: "Ł" },
  SOL: { color: "#9945ff", glyph: "S" },
  DOGE: { color: "#c2a633", glyph: "Ð" },
  BCH: { color: "#0ac18e", glyph: "₿" },
  XRP: { color: "#23292f", glyph: "✕" },
  TRX: { color: "#ff060a", glyph: "T" },
  INR: { color: "#1fc16b", glyph: "₹" },
};

function getCurrencyTheme(code) {
  const upperCode = String(code || "").toUpperCase();
  return CURRENCY_THEME[upperCode] || { color: "#7b61ff", glyph: upperCode.charAt(0) };
}

const formatBalance = (amount, code, activeDbCurrencies = null) => {
  const val = parseFloat(amount || 0);
  const coinCode = String(code || "").toLowerCase();
  
  let decimals = null;
  if (activeDbCurrencies && Array.isArray(activeDbCurrencies)) {
    const cur = activeDbCurrencies.find(c => c.code.toLowerCase() === coinCode);
    if (cur && typeof cur.decimals === 'number') {
      decimals = cur.decimals;
    }
  }

  if (decimals === null) {
    if (coinCode === 'inr' || coinCode === 'usd') {
      decimals = 2;
    } else {
      decimals = 8;
    }
  }

  if (decimals === 2 && coinCode === 'inr') {
    return val.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return val.toFixed(decimals);
};

const formatHeaderBalance = (amount, code, activeDbCurrencies = null) => {
  const val = parseFloat(amount || 0);
  const coinCode = String(code || "").toLowerCase();
  
  // Always use 2 decimal places for the main header balance bar to save space on mobile
  const decimals = 2;

  if (coinCode === 'inr') {
    return val.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return val.toFixed(decimals);
};

const getCoinImageOrGlyph = (code, imageUrl, symbol) => {
  const theme = getCurrencyTheme(code);
  // 1. Admin-uploaded logo (stored in public/uploads/currencies/ or absolute NOWPayments URL)
  if (imageUrl) {
    let finalUrl = imageUrl;
    if (imageUrl.includes('http://') || imageUrl.includes('https://')) {
      const httpIndices = [];
      let idx = imageUrl.indexOf('http');
      while (idx !== -1) {
        httpIndices.push(idx);
        idx = imageUrl.indexOf('http', idx + 1);
      }
      if (httpIndices.length > 1) {
        finalUrl = imageUrl.substring(httpIndices[httpIndices.length - 1]);
      }
    }
    return (
      <img
        src={finalUrl}
        style={{ width: "22px", height: "22px", objectFit: "contain", borderRadius: "50%" }}
        alt={code}
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    );
  }
  // 2. Static coin image bundled with the frontend
  const coinMeta = coins.find(item => item.preffix.toLowerCase() === (code || "").toLowerCase());
  if (coinMeta && coinMeta.image) {
    return (
      <img
        src={"/assets/images/" + coinMeta.image}
        style={{ width: "22px", height: "22px", objectFit: "contain" }}
        alt={code}
      />
    );
  }
  // 3. Fallback: show symbol text (from DB) inside a coloured circle
  const displayText = symbol ? symbol : theme.glyph;
  return (
    <div 
      style={{
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        fontSize: displayText.length > 2 ? "7px" : "10px",
        fontWeight: "bold",
        color: "#fff",
        background: theme.color,
        overflow: "hidden",
        letterSpacing: "-0.5px",
      }}
    >
      {displayText}
    </div>
  );
};

const DropdownItemButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: ${props => props.active ? "rgba(36, 238, 137, 0.1)" : "transparent"};
  border: none;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  margin: 4px 0;
  transition: all 0.2s ease-in-out;
  outline: none;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

class Credit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showManage: false,
      isTransferIn: true,
      token: storage.getKey("token"),
      coin: storage.getKey("coin"),
      activeClientCoins: storage.getKey("active_coins")
        ? storage.getKey("active_coins")
        : null,
      selectedCoin: storage.getKey("coin"),
      credits: {},
      coins: [],
      uid: getUID,
      manage_coins: [],
      different: [],
      credit: false,
      usd: storage.getKey("usd") === "true" ? true : false,
      searchTerm: "",
      showWalletModal: false,
      modalStep: "home",
      showCurrencyModal: false,
      activeSection: "deposit",
      activeTab: "deposit", // Default to Deposit
      selectedCoinSwapSend: "INR",
      creditSWapSend: 0,
      isModalOpenSwapSend: false,
      selectedCoinSwapApprox: "INR",
      creditSWapApprox: 0,
      isModalOpenSwapApprox: false,
      selectedCoinTransferIn: "INR",
      creditTransferIn: 0,
      isModalOpen: false,
      isModalOpenTransferIn: false,
      selectedCoinTransferOut: "INR",
      creditTransferOut: 0,
      isModalOpenTransferOut: false,
      amountTransferOut: "",
      amountTransferIn: "",
      vaultAmount: null,
      errorSend: "",
      openTransacationModal: false,
      displayDirection: "USD_TO_BDT",
      currencyRates: FALLBACK_CURRENCY_RATES,
      ratesLoaded: false,
      activeDbCurrencies: [
        { code: "inr", name: "Indian Rupee", symbol: "₹" },
        { code: "usdt", name: "Tether", symbol: "$" },
        { code: "btc", name: "Bitcoin", symbol: "₿" },
        { code: "eth", name: "Ethereum", symbol: "Ξ" }
      ],
    };
    this.selectCoin = this.selectCoin.bind(this);
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.sections = [
      { id: "deposit", label: "Deposit", icon: Wallet },
      { id: "withdraw", label: "Withdraw", icon: WalletCards },
      { id: "swap", label: "Swap", icon: ArrowDownUp },
      { id: "vaultpro", label: "Vault Pro", icon: Vault },
    ];
  }

  handleVualtInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  // Toggle Modal Function
  toggleModal = () => {
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen, // Toggle modal open/close
    }));
  };
  toggleModalTransaction = () => {
    this.setState((prevState) => ({
      openTransacationModal: !prevState.openTransacationModal, // Toggle modal open/close
    }));
  };

  // Open Modal with active section (Deposit/Withdraw)
  openModal = (tab) => {
    this.setState({
      isModalOpen: true,
      activeTab: tab, // Set active tab when modal opens
    });
  };

  handleTransfer = async () => {
    const {
      isTransferIn,
      selectedCoinTransferIn,
      selectedCoinTransferOut,
      amountTransferIn,
      amountTransferOut,
      uid,
    } = this.state;
    const coin = isTransferIn
      ? selectedCoinTransferIn
      : selectedCoinTransferOut;
    const amount = isTransferIn
      ? Number(amountTransferIn)
      : Number(amountTransferOut);
    const endpoint = isTransferIn ? "transfer-in" : "transfer-out";

    if (
      amount <= 0 ||
      (isTransferIn && this.state.creditTransferIn < amount) ||
      (!isTransferIn && this.state.creditTransferOut < amount)
    ) {
      this.setState({ errorSend: "Please enter a valid amount" });
      return;
    }

    try {
      const response = await this.props.transferVaultLocal({
        endpoint,
        uid,
        coin,
        amount,
      });

      console.log(
        `Transferred ${isTransferIn ? "to" : "from"} Vault Pro:`,
        response
      );
      sendNotfication(response?.message || response?.data?.message, "success", "bottom-left");
      // this.handleSuccessfulTransfer(response.data);
    } catch (error) {
      console.error("Transfer failed:", error);
      // this.handleTransferError(error);
    }
  };

  handleCoinChange = (coin) => {
    this.setState({ selectedCoinSwapSend: coin });
  };

  handleCreditChange = (newCredit) => {
    this.setState({ creditSWapSend: newCredit });
  };

  openModal = () => {
    this.setState({ isModalOpenSwapSend: true });
  };

  closeModal = () => {
    this.setState({ isModalOpenSwapSend: false });
  };

  handleCoinChangeApprox = (coin) => {
    this.setState({ selectedCoinSwapApprox: coin });
  };

  handleCreditChangeApprox = (newCredit) => {
    this.setState({ creditSWapApprox: newCredit });
  };

  openModalApprox = () => {
    this.setState({ isModalOpenSwapApprox: true });
  };

  closeModalApprox = () => {
    this.setState({ isModalOpenSwapApprox: false });
  };

  handleCoinTranserferIn = (coin) => {
    this.setState({ selectedCoinTransferIn: coin });
  };

  handleCreditTransferIn = (newCredit) => {
    this.setState({ creditTransferIn: newCredit });
  };

  openModalTransferIn = () => {
    this.setState({ isModalOpenTransferIn: true });
  };

  closeModalTransferIn = () => {
    this.setState({ isModalOpenTransferIn: false });
  };

  handleCoinTranserferOut = async (coin) => {
    this.setState({ selectedCoinTransferOut: coin });
    try {
      const response = await axios.post(
        `${API}/vault-data`,
        {
          uid: this.state.uid,
          coin: this.state.selectedCoinTransferOut,
        }
      );

      console.log("vaulelee", response);
      this.setState({ vaultAmount: response.data.vaultBalance });
    } catch (error) {
      console.error("Error fetching vault amount:", error);
      // Handle error (e.g., show error message to user)
    }
  };

  handleCreditTransferOut = (newCredit) => {
    this.setState({ creditTransferOut: newCredit });
  };

  openModalTransferOut = () => {
    this.setState({ isModalOpenTransferOut: true });
  };

  closeModalTransferOut = () => {
    this.setState({ isModalOpenTransferOut: false });
  };

  setActiveSection = (sectionId) => {
    this.setState({ activeSection: sectionId });
  };

  removeSocketListeners = () => {
    this.socket.off(C.CREDIT, this.handleCredit);
    this.socket.off(C.UPDATE_CREDIT, this.updateCredit);
  };

  componentWillUnmount() {
    this.removeSocketListeners();
    if (this.balanceInterval) {
      clearInterval(this.balanceInterval);
    }
  }

  componentDidMount() {
    //Get Redux Coin
    this.props.gameCoin();

    axios.get(`${API}/api/currencies`)
      .then((res) => {
        if (res.data && res.data.success) {
          const dbCurrencies = res.data.currencies;
          window.activeDbCurrencies = dbCurrencies;
          this.setState({
            activeDbCurrencies: dbCurrencies,
          });

          const defaultCurrency = dbCurrencies.find(c => c.is_default) || dbCurrencies[0];
          let currentSelectedCoin = storage.getKey("coin") || (defaultCurrency ? defaultCurrency.code : null);
          
          if (currentSelectedCoin) {
            const isActive = dbCurrencies.find(c => c.code.toLowerCase() === (currentSelectedCoin || "").toLowerCase());
            if (!isActive && defaultCurrency) {
              currentSelectedCoin = defaultCurrency.code.toUpperCase();
            }
          }

          if (currentSelectedCoin) {
            this.setState({ selectedCoin: currentSelectedCoin.toUpperCase(), coin: currentSelectedCoin.toUpperCase() });
            storage.setKey("coin", currentSelectedCoin.toUpperCase());
            this.props.setCoin(currentSelectedCoin.toUpperCase());
          }

          this.updateAllCoins();
        }
      })
      .catch((err) => {
        console.error("Failed to fetch currencies from API:", err);
      });

    Event.on("other_coins", () => {
      this.setState({ showManage: true });
    });

    Event.on("open_wallet_with_tab", (tab) => {
      this.setState({
        showWalletModal: true,
        modalStep: "home",
        walletInitialStep: tab === "swap" ? "swap" : "home",
        showCurrencyModal: false
      });
    });

    Event.on("login", (loginData) => {
      const token = loginData?.token || storage.getKey("token");
      const uid = parseFloat(loginData?.id || loginData?.uid || Cookies.get("uid"));
      this.setState({ token: token, uid: uid }, () => {
        if (token) {
          const emitCredit = () => {
            socket.emit(
              C.CREDIT,
              encode({ token: token, coin: this.state.coin })
            );
          };

          if (socket.connected) {
            emitCredit();
          } else {
            socket.once("connect", emitCredit);
          }
        }
      });
    });

    console.log("uid is", this.state.uid);

    if (this.state.token !== null)
      socket.emit(
        C.CREDIT,
        encode({ token: this.state.token, coin: this.state.coin })
      );

    socket.on(C.CREDIT, (data) => this.getCredit(decode(data)));
    socket.on(C.UPDATE_CREDIT, (data) => this.updateCredit(decode(data)));

    // Auto-poll balance every 10 seconds if user is logged in
    this.balanceInterval = setInterval(() => {
      if (this.state.token) {
        socket.emit(
          C.CREDIT,
          encode({ token: this.state.token, coin: this.state.coin })
        );
      }
    }, 10000);

    if (this.state.activeClientCoins === null) {
      var arr = [];
      for (var i = 1; i < 8; i++) {
        arr.push(i);
      }
      storage.setKey("active_coins", arr);
    }

    this.setUpManageCoins();

    if (this.state.showManage) {
      wait(1000).then(() => {
        const ps = new PerfectScrollbar(".ccoins", {
          wheelSpeed: 1,
          suppressScrollX: true,
          wheelPropagation: true,
          minScrollbarLength: 2,
        });
        ps.update();
      });
    }

    this.fetchCurrencyRates();

    window.addEventListener("wheel", this.handleScroll, { passive: false });
    window.addEventListener("mousedown", this.handleClickOutside);
  }

  normalizeRates = (rawRates) => {
    if (!rawRates || typeof rawRates !== "object") return null;

    const bdtRate = Number(rawRates.INR);
    if (!Number.isFinite(bdtRate) || bdtRate <= 0) return null;

    return {
      USD: 1,
      INR: bdtRate,
    };
  };

  fetchCurrencyRates = async () => {
    const providers = [
      async () => {
        const response = await axios.get("https://open.er-api.com/v6/latest/USD");
        return this.normalizeRates(response?.data?.rates);
      },
      async () => {
        const response = await axios.get("https://api.exchangerate-api.com/v4/latest/USD");
        return this.normalizeRates(response?.data?.rates);
      },
      async () => {
        const response = await axios.get("https://api.exchangerate.host/latest", {
          params: { base: "USD" },
        });
        return this.normalizeRates(response?.data?.rates);
      },
    ];

    for (const loadRates of providers) {
      try {
        const rates = await loadRates();
        if (rates) {
          this.setState({
            currencyRates: {
              ...FALLBACK_CURRENCY_RATES,
              ...rates,
            },
            ratesLoaded: true,
          });
          return;
        }
      } catch (error) {
        // Try next provider.
      }
    }

    this.setState({
      currencyRates: FALLBACK_CURRENCY_RATES,
      ratesLoaded: false,
    });
  };

  parseNumericAmount = (value) => {
    const parsed = parseFloat(String(value || "0").replace(/[^0-9.-]/g, ""));
    if (Number.isNaN(parsed)) return 0;
    return parsed;
  };

  formatByCurrency = (amount, currency) => {
    const symbol = CURRENCY_SYMBOLS[currency] || "";
    return `${symbol}${Number(amount || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  toggleDisplayDirection = () => {
    this.setState((prevState) => ({
      displayDirection:
        prevState.displayDirection === "USD_TO_BDT"
          ? "BDT_TO_USD"
          : "USD_TO_BDT",
    }));
  };

  //  const sessionCookie = Cookies.get("session");

  toggleWalletModal = (e) => {
    e.stopPropagation();
    this.setState((prevState) => ({
      showWalletModal: !prevState.showWalletModal,
      modalStep: "home",
      show: false,
      showWallet: false,
    }));
  };

  openWalletModal = (e) => {
    e.stopPropagation();
    this.setState({ showWalletModal: true, modalStep: "home", show: false });
  };

  onDepositFromHome = () => {
    this.setState({ showWalletModal: false, showDynamicDeposit: true, activeTab: "Deposit" });
  };

  onWithdrawFromHome = () => {
    this.setState({ showWalletModal: false, showDynamicWithdrawal: true });
  };

  toggleCurrencytModal = (e) => {
    e.stopPropagation();
    this.setState((prevState) => ({
      // showWalletModal:false,
      showCurrencyModal: !prevState.showCurrencyModal,
      show: false,
      showWallet: false,
    }));
  };

  handleScroll(e) {
    // Allow native scroll inside the currency list inner container
    const scrollableInner = document.querySelector('.filter-coins-main-in');
    if (scrollableInner && scrollableInner.contains(e.target)) {
      return; // let browser scroll the list naturally
    }

    let creditBody = document.querySelector(".prevscrol");
    if (creditBody) {
      creditBody.scrollTop -= e.wheelDeltaY;
      e = e || window.event;
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    }
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ show: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("wheel", this.handleScroll, { passive: false });
    window.removeEventListener("mousedown", this.handleClickOutside);
  }

  activeCoinChange = (id, active) => {
    if (id === 1) return;
    const activeClientCoins = storage.getKey("active_coins");
    let update;

    if (!active) {
      update = activeClientCoins + "," + id;
    } else {
      update = __.replace(activeClientCoins, "," + id, "");
    }

    update = __.replace(update, null, "");

    const compareNumbers = (a, b) => a - b;

    let arr = [];

    const regex = /(\d+)/gi;
    let m;

    while ((m = regex.exec(update)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      m.forEach((match, groupIndex) => {
        match = parseFloat(match);
        arr.push(match);
      });
    }

    arr.sort(compareNumbers);
    var c = __.xor(arr);

    storage.setKey("active_coins", c);

    this.setUpManageCoins();
  };

  setUpManageCoins = () => {
    const { t } = this.props;
    let self = this;

    this.setState({ manage_coins: [] });

    let activeCurrencies = [];
    if (this.state.activeDbCurrencies && this.state.activeDbCurrencies.length > 0) {
      activeCurrencies = this.state.activeDbCurrencies.map(c => ({
        id: c.id,
        name: c.name,
        preffix: c.code,
        image: c.image_url ? (c.image_url.startsWith('http') ? c.image_url : `${API}/uploads/currencies/${c.image_url}`) : `${c.code}.png`,
        min: "0",
        active: c.is_active,
        test: false,
        network: "N/A",
        isDb: true
      }));
    } else {
      activeCurrencies = coins;
    }

    const activeCoins = storage.getKey("active_coins");
    let ac = __.split(activeCoins, ",");

    activeCurrencies.forEach((item, key) => {
      //Default
      if (activeCoins === null) {
        let add = (
          <Dropdown.Item key={key} className={"num-style"}>
            <div
              style={{ color: "white" }}
              className="float-left text-white ncpt"
            >
              {item.isDb && item.image.startsWith('http') ? (
                <img src={item.image} alt="coin" className={"mini-coin-12"} />
              ) : (
                <img src={"/assets/images/" + item.image} alt="coin" className={"mini-coin-12"} />
              )}
              {item.preffix}
            </div>
            <div className="float-right">
              <div className="custom-control custom-switch switch-success">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={"switch_" + key}
                  checked={true}
                />
                <label
                  onClick={(e) =>
                    self.activeCoinChange(parseFloat(item.id), true)
                  }
                  className={"custom-control-label"}
                  htmlFor={"switch_" + key}
                >
                  {item.name}
                </label>
              </div>
            </div>
          </Dropdown.Item>
        );
        return self.setState((state) => ({
          manage_coins: [add, ...state.manage_coins],
        }));
      }

      let active = false;

      let check = ac.some(
        (element) => parseFloat(element) === parseFloat(item.id)
      );

      if (check) {
        active = true;
      }

      var disabled = false;

      if (item.preffix === "BTC") disabled = true;

      let add = (
        <Dropdown.Item
          style={{ color: "white" }}
          key={key}
          className={"num-style"}
        >
          <div
            style={{ color: "white", display: "flex", gap: "5px" }}
            className="float-left text-white ncpt"
          >
            {item.isDb && item.image.startsWith('http') ? (
              <img src={item.image} alt="coin" className={"mini-coin-12"} />
            ) : (
              <img src={"/assets/images/" + item.image} alt="coin" className={"mini-coin-12"} />
            )}
            <div style={{ fontWeight: "600" }}>{item.preffix}</div>

            <div style={{ color: "#B3BEC1", fontWeight: "600" }}>
              {item.name}
            </div>
          </div>
          <div className="float-right">
            <div className="custom-control custom-switch switch-success">
              <input
                type="checkbox"
                className="custom-control-input"
                id={"switch_" + key}
                checked={active}
                disabled={disabled}
              />
              <label
                onClick={(e) =>
                  self.activeCoinChange(parseFloat(item.id), active)
                }
                className="custom-control-label"
                htmlFor={"switch_" + key}
              >
                {/* {item.name} */}
              </label>
            </div>
          </div>
        </Dropdown.Item>
      );
      self.setState((state) => ({
        manage_coins: [add, ...state.manage_coins],
      }));
    });
  };

  updateAllCoins(newCoin = null, newVal = null) {
    const activeClientCoins = storage.getKey("active_coins");
    this.setState({ coins: [] });

    let activeCurrencies = [];
    if (this.state.activeDbCurrencies && this.state.activeDbCurrencies.length > 0) {
      activeCurrencies = this.state.activeDbCurrencies.map(c => ({
        id: c.id,
        name: c.name,
        preffix: c.code,
        image: c.image_url ? (c.image_url.startsWith('http') ? c.image_url : `${API}/uploads/currencies/${c.image_url}`) : `${c.code}.png`,
        min: "0",
        active: c.is_active,
        test: false,
        network: "N/A",
        isDb: true
      }));
    } else {
      activeCurrencies = coins;
    }

    let ac = null,
      style,
      value,
      coin;

    if (activeClientCoins !== null) {
      ac = activeClientCoins.split(",");

      __.reverse(ac).forEach((num, key) => {
        var item = __.find(activeCurrencies, { id: parseFloat(num) });
        if (__.isUndefined(item)) return;
        style =
          __.lowerCase(item.preffix) === __.lowerCase(this.state.selectedCoin)
            ? "actc"
            : "";

        if (newVal !== null) value = newVal;
        else
          value = forceSatoshiFormat(
            this.state.credits[__.lowerCase(item.preffix)]
          );

        if (__.lowerCase(item.preffix) === newCoin) {
          this.state.credits[newCoin] = value;
        }

        if (newCoin !== null) {
          coin = (
            <Dropdown.Item
              onClick={(e) => this.selectCoin(item.preffix, newCoin, newVal)}
              key={key}
              className={"num-style " + style}
            >
              <div style={{ color: "white" }} className="float-left">
                {item.isDb && item.image.startsWith('http') ? (
                  <img src={item.image} alt="coin" className={"mini-coin-7"} />
                ) : (
                  <img src={"/assets/images/" + item.image} alt="coin" className={"mini-coin-7"} />
                )}
                {item.preffix}
              </div>
              {__.lowerCase(item.preffix) === newCoin ? (
                <div style={{ color: "white" }} className="float-right">
                  {value}
                </div>
              ) : (
                <div style={{ color: "white" }} className="float-right">
                  {forceSatoshiFormat(
                    this.state.credits[__.lowerCase(item.preffix)]
                  )}
                </div>
              )}
            </Dropdown.Item>
          );
        } else {
          coin = (
            <Dropdown.Item
              onClick={(e) => this.selectCoin(item.preffix)}
              key={key}
              className={"num-style " + style}
            >
              <div style={{ color: "white" }} className="float-left">
                {item.isDb && item.image.startsWith('http') ? (
                  <img src={item.image} alt="coin" className={"mini-coin-7"} />
                ) : (
                  <img src={"/assets/images/" + item.image} alt="coin" className={"mini-coin-7"} />
                )}
                {item.preffix}
              </div>
              <div style={{ color: "white" }} className="float-right">
                {value}
              </div>
            </Dropdown.Item>
          );
        }

        this.setState((state) => ({ coins: [coin, ...state.coins] }));
      });
    } else {
      activeCurrencies.forEach((item, key) => {
        if (ac !== null) {
          let check = ac.some(
            (element) => parseFloat(element) === parseFloat(item.id)
          );

          if (check) {
            style =
              __.lowerCase(item.preffix) ===
                __.lowerCase(this.state.selectedCoin)
                ? "actc"
                : "";
            value = forceSatoshiFormat(
              this.state.credits[__.lowerCase(item.preffix)]
            );
            coin = (
              <Dropdown.Item
                onClick={(e) => this.selectCoin(item.preffix)}
                key={key}
                className={"num-style " + style}
              >
                <div style={{ color: "white" }} className="float-left">
                  {item.isDb && item.image.startsWith('http') ? (
                    <img src={item.image} alt="coin" className={"mini-coin-7"} />
                  ) : (
                    <img src={"/assets/images/" + item.image} alt="coin" className={"mini-coin-7"} />
                  )}
                  {item.preffix}
                </div>
                <div style={{ color: "white" }} className="float-right">
                  {value}
                </div>
              </Dropdown.Item>
            );
          }
        } else {
          style =
            __.lowerCase(item.preffix) === __.lowerCase(this.state.selectedCoin)
              ? "actc"
              : "";
          value = forceSatoshiFormat(
            this.state.credits[__.lowerCase(item.preffix)]
          );
          coin = (
            <Dropdown.Item
              onClick={(e) => this.selectCoin(item.preffix)}
              key={key}
              className={"num-style " + style}
            >
              <div style={{ color: "white" }} className="float-left">
                {item.isDb && item.image.startsWith('http') ? (
                  <img src={item.image} alt="coin" className={"mini-coin-7"} />
                ) : (
                  <img src={"/assets/images/" + item.image} alt="coin" className={"mini-coin-7"} />
                )}
                {item.preffix}
              </div>
              <div style={{ color: "white" }} className="float-right">
                {value}
              </div>
            </Dropdown.Item>
          );
        }
        this.setState((state) => ({ coins: [coin, ...state.coins] }));
      });
    }
  }

  openWalletModal = (e) => {
    e.stopPropagation();
    this.setState({ showWalletModal: true, show: false });
  };

  closeWalletModal = () => {
    this.setState({ showWalletModal: false });
  };
  getCredit(data) {
    let { credit } = data;

    this.setState({ credits: credit });

    let currentCoin = __.lowerCase(this.props.coin);
    let currentCredit = forceSatoshiFormat(this.state.credits[currentCoin]);
    this.setState({ credit: currentCredit });
    storage.setKey("credit", currentCredit);

    //Set for Redux
    this.props.setCredit(currentCredit);
    this.updateAllCoins();
  }

  updateCredit(data) {
    let credit = data.value;
    let coin = data.coin;

    let different;
    let arr;

    if (__.toNumber(credit) > __.toNumber(this.state.credit)) {
      different = __.toNumber(credit) - __.toNumber(this.state.credit);
      arr = {
        amount: different,
        color: "text-success",
      };
    } else {
      different = __.toNumber(this.state.credit) - __.toNumber(credit);
      arr = {
        amount: different,
        color: "text-danger",
      };
    }

    let check = forceSatoshiFormat(different);

    if (check.toString() !== "0.00000000") {
      this.setState((state) => ({ different: [arr, ...state.different] }));
    }

    var realCredit = credit;
    credit = forceSatoshiFormat(credit);

    this.setState({ credit: credit });
    storage.setKey("credit", credit);

    this.updateParentCoin(__.lowerCase(coin), credit);
    this.updateAllCoins(__.lowerCase(coin), realCredit);

    //Set for Redux
    this.props.setCredit(credit);
  }

  updateParentCoin(coin, amount) {
    this.setState({ coins: [] });

    let activeCurrencies = [];
    if (this.state.activeDbCurrencies && this.state.activeDbCurrencies.length > 0) {
      activeCurrencies = this.state.activeDbCurrencies.map(c => ({
        id: c.id,
        name: c.name,
        preffix: c.code,
        image: c.image_url ? (c.image_url.startsWith('http') ? c.image_url : `${API}/uploads/currencies/${c.image_url}`) : `${c.code}.png`,
        min: "0",
        active: c.is_active,
        test: false,
        network: "N/A",
        isDb: true
      }));
    } else {
      activeCurrencies = coins;
    }

    activeCurrencies.forEach((item, key) => {
      if (__.lowerCase(item.preffix) === coin) {
        const style =
          __.lowerCase(item.preffix) === __.lowerCase(this.state.selectedCoin)
            ? "actc"
            : "";
        let update = (
          <Dropdown.Item
            onClick={(e) => this.selectCoin(__.upperCase(coin))}
            key={key}
            className={"num-style " + style}
          >
            <div style={{ color: "white" }} className="float-left">
              {item.isDb && item.image.startsWith('http') ? (
                <img src={item.image} alt="coin" className={"mini-coin-7"} />
              ) : (
                <img src={"/assets/images/" + item.image} alt="coin" className={"mini-coin-7"} />
              )}
              {item.preffix}
            </div>
            <div style={{ color: "white" }} className="float-right">
              {forceSatoshiFormat(amount)}
            </div>
          </Dropdown.Item>
        );
        this.setState((state) => ({ coins: [update, ...state.coins] }));
      } else {
        const style =
          __.lowerCase(item.preffix) === __.lowerCase(this.state.selectedCoin)
            ? "actc"
            : "";
        let value = forceSatoshiFormat(
          this.state.credits[__.lowerCase(item.preffix)]
        );
        let update = (
          <Dropdown.Item
            onClick={(e) => this.selectCoin(item.preffix)}
            key={key}
            className={"num-style " + style}
          >
            <div style={{ color: "white" }} className="float-left">
              {item.isDb && item.image.startsWith('http') ? (
                <img src={item.image} alt="coin" className={"mini-coin-7"} />
              ) : (
                <img src={"/assets/images/" + item.image} alt="coin" className={"mini-coin-7"} />
              )}
              {item.preffix}
            </div>
            <div style={{ color: "white" }} className="float-right">
              {value}
            </div>
          </Dropdown.Item>
        );
        this.setState((state) => ({ coins: [update, ...state.coins] }));
      }
    });
  }

  selectCoin(name, newCoin, newVal) {
    //Fix For Double selection
    if (storage.getKey("coin") === name) return;
    storage.setKey("coin", name);

    let credit = this.state.credits[__.lowerCase(name)];
    this.setState({
      coin: name,
      show: false,
      credit: credit,
      selectedCoin: name,
      showCurrencyModal: false,
    });

    //Set Coin For Redux
    this.props.setCoin(name);
    this.props.setCredit(credit);

    wait(200).then(() => {
      this.updateAllCoins(newCoin, newVal);
      Event.emit("coin_changed", name);
    });
  }

  addDiff(data, i) {
    let id = "id_" + Math.floor(Math.random() * 1000 + 1);

    wait(2000).then(() => {
      try {
        document.getElementById(id).classList.remove("frd");
        document.getElementById(id).classList.add("fadeOutDown");
      } catch (e) { }
      this.state.different.splice(i, 1);
    });

    return (
      <li
        key={i}
        id={id}
        className={"list-inline w-100 text-right animated frd " + data.color}
      >
        {" "}
        {data.color === "text-danger" ? "-" : "+"}
        {forceSatoshiFormat(data.amount, this.state.coin)}
      </li>
    );
  }

  closeManage = () => {
    this.setState({ showManage: false });
    wait(200).then(() => {
      this.updateAllCoins();
    });
  };

  manageCoins = () => {
    this.setState({ showManage: true });
  };

  open = (e) => {
    this.setState({ show: !this.state.show });
  };

  usdformat = () => {
    this.setState({ usd: !this.state.usd });
    wait(1000).then(() => {
      storage.setKey("usd", this.state.usd);
    });
  };
  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  filteredCoins = () => {
    const { searchTerm, coins } = this.state;
    return coins.filter((coin) => {
      const coinText = coin.props.children
        .map((child) => {
          if (typeof child === "string") {
            return child.toLowerCase();
          }
          return "";
        })
        .join(" ");
      return coinText.includes(searchTerm.toLowerCase());
    });
  };

  filteredCoinsCurrency = () => {
    const { searchTerm, coins } = this.state;
    return coins.filter((coin) => {
      const coinText = coin.props.children
        .map((child) => {
          if (typeof child === "string") {
            return child.toLowerCase();
          }
          return "";
        })
        .join(" ");
      return coinText.includes(searchTerm.toLowerCase());
    });
  };

  openCoinDropdown = (e) => {
    e.stopPropagation();
    this.setState({ show: !this.state.show, showWallet: false });
  };

  openWalletDropdown = (e) => {
    e.stopPropagation();
    this.setState({ showWallet: !this.state.showWallet, show: false });
  };
  toggleTransfer = async () => {
    const newIsTransferIn = !this.state.isTransferIn;
    this.setState({ isTransferIn: newIsTransferIn });

    try {
      const response = await this.props.getVaultDataLocal({
        uid: this.state.uid,
        coin: this.state.selectedCoinTransferOut,
      });

      console.log("vaulelee", response);
      this.setState({ vaultAmount: response.vaultBalance || response?.data?.vaultBalance });
    } catch (error) {
      console.error("Error fetching vault amount:", error);
      // Handle error (e.g., show error message to user)
    }
  };

  render() {
    let {
      credit,
      different,
      coin,
      coins,
      show,
      showWallet,
      searchTerm,
      isModalOpen,
    } = this.state;
    const { selectedCoinSwapSend, creditSWapSend } = this.state;
    credit = forceSatoshiFormat(credit, coin, this.state.usd);
    const { displayDirection, currencyRates } = this.state;
    const baseUsdAmount = this.parseNumericAmount(credit);
    const usdToBdtRate =
      currencyRates.INR ??
      FALLBACK_CURRENCY_RATES.INR ??
      null;
    const bdtAmount = usdToBdtRate ? baseUsdAmount * usdToBdtRate : null;
    const isUsdToBdt = displayDirection === "USD_TO_BDT";
    const primaryCurrency = isUsdToBdt ? "USD" : "INR";
    const secondaryCurrency = isUsdToBdt ? "INR" : "USD";
    const primaryAmount = isUsdToBdt ? baseUsdAmount : bdtAmount;
    const secondaryAmount = isUsdToBdt ? bdtAmount : baseUsdAmount;
    const primaryText =
      primaryAmount !== null
        ? this.formatByCurrency(primaryAmount, primaryCurrency)
        : "Rate unavailable";
    const secondaryText =
      secondaryAmount !== null
        ? `~ ${this.formatByCurrency(secondaryAmount, secondaryCurrency)}`
        : "Rate unavailable";
    const switchLabel = isUsdToBdt ? "To INR" : "To USD";
    const { isTransferIn } = this.state;
    let diff = different.map((data, i) => this.addDiff(data, i));

    const { activeSection } = this.state;

    const { isModalOpenTransferIn, isModalOpenTransferOut } = this.state;

    const coinDropdownStyle = show ? "show prevscrol" : "d-nones";
    const walletDropdownStyle = showWallet ? "show prevscrol" : "d-nones";
    const filteredCoins = this.filteredCoins();
    const filteredCoinsCurrency = this.filteredCoinsCurrency();

    return (
      <>
        <li style={{ position: "relative" }}>
          <div className="crypto-balance" ref={this.wrapperRef}>
            <ul id="cup2" className={"mt-2 mr-1"}>
              {diff}
            </ul>
            <div className="btc-balance">
              <div
                className={
                  "navbar-wallet clist mt-0 text-right float-right cpt"
                }
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <Container style={{ cursor: "pointer", display: "flex", alignItems: "center", minHeight: "36px", padding: "0.2rem 0.5rem" }} onClick={this.openCoinDropdown}>
                    <CubBalance style={{ margin: 0, padding: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <div className="d-none d-sm-flex" style={{ alignItems: "center" }}>
                            {(() => {
                              const activeCurrencyData = (this.state.activeDbCurrencies || []).find(c => c.code.toLowerCase() === (coin || "").toLowerCase());
                              const imgUrl = activeCurrencyData && activeCurrencyData.image_url ? `${API}/uploads/currencies/${activeCurrencyData.image_url}` : null;
                              const sym = activeCurrencyData ? activeCurrencyData.symbol : null;
                              return getCoinImageOrGlyph(coin, imgUrl, sym);
                            })()}
                          </div>
                          <span style={{ color: "#fff", fontSize: "14px", fontWeight: "700", textTransform: "uppercase" }}>
                            {coin}
                          </span>
                        </div>
                        <AmountLine style={{ fontSize: "13px", fontWeight: "bold", color: "#fff", borderLeft: "1px solid #3f494b", paddingLeft: "8px" }}>
                          {formatHeaderBalance(this.state.credits[(coin || "").toLowerCase()] || 0.0, coin, this.state.activeDbCurrencies)}
                        </AmountLine>
                        <BiChevronDown 
                          size={18} 
                          style={{
                            color: "#8c8c8c",
                            transition: "transform 0.2s",
                            transform: show ? "rotate(180deg)" : "none"
                          }}
                        />
                      </div>
                    </CubBalance>
                  </Container>

                  <HeaderDepositButton onClick={this.openWalletModal}>
                    Deposit
                  </HeaderDepositButton>
                  <DynamicDeposit 
                    style={{ display: "none" }} 
                    forceOpen={this.state.showDynamicDeposit} 
                    defaultTab={this.state.activeTab}
                    onForceClose={() => this.setState({ showDynamicDeposit: false })} 
                  />
                  <DynamicWithdrawal
                    forceOpen={this.state.showDynamicWithdrawal}
                    onForceClose={() => this.setState({ showDynamicWithdrawal: false })}
                  />
                </div>
              </div>
              <div
                className={"num-style coins-list clist " + coinDropdownStyle}
                onClick={(e) => {
                  if (
                    e.target.matches(".search-bar, .search-bar *") ||
                    e.target.matches(".clist, .clist *") ||
                    e.target.matches("input")
                  ) {
                    return;
                  }
                  this.setState({ show: false });
                }}
              >
                <div style={{ display: "flex", width: "100%", marginBottom: "10px" }}>
                  <div
                    className="search-bar"
                    ref={(div) => {
                      this.searchBarDiv = div;
                    }}
                    style={{
                      width: "100%",
                      border: "1px solid transparent",
                      borderRadius: "11px",
                      transition: "border 0.2s ease",
                    }}
                  >
                    <SearchContainer>
                      <Search color="#B3BEC1" size={18} />
                      <input
                        type="text"
                        style={{ fontWeight: "600", color: "#B3BEC1" }}
                        placeholder="Search currencies..."
                        value={searchTerm}
                        onChange={this.handleSearch}
                        onClick={(e) => e.stopPropagation()}
                        onFocus={() => {
                          if (this.searchBarDiv) this.searchBarDiv.style.border = "1px solid #24EE89";
                        }}
                        onBlur={() => {
                          if (this.searchBarDiv) this.searchBarDiv.style.border = "2px solid transparent";
                        }}
                      />
                    </SearchContainer>
                  </div>
                </div>
                <div
                  className="filter-coins-main-in"
                  style={{ height: "320px", overflowY: "auto", overscrollBehavior: "contain" }}
                  onWheel={(e) => e.stopPropagation()}
                >
                  {(() => {
                    const filteredDbCurrencies = (this.state.activeDbCurrencies || []).filter(c => {
                      const code = (c.code || "").toLowerCase();
                      const name = (c.name || "").toLowerCase();
                      const term = (searchTerm || "").toLowerCase();
                      return code.includes(term) || name.includes(term);
                    });
                    if (filteredDbCurrencies.length === 0) {
                      return (
                        <div style={{ padding: "20px", textAlign: "center", color: "#8c8c8c" }}>
                          No active currencies found
                        </div>
                      );
                    }
                    return filteredDbCurrencies.map((c) => {
                      const active = (coin || "").toLowerCase() === c.code.toLowerCase();
                      const balanceVal = this.state.credits[c.code.toLowerCase()] || 0.0;
                      return (
                        <DropdownItemButton
                          key={c.code}
                          active={active}
                          onClick={() => {
                            this.selectCoin(c.code.toUpperCase());
                          }}
                        >
                          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {getCoinImageOrGlyph(c.code, c.image_url ? `${API}/uploads/currencies/${c.image_url}` : null, c.symbol)}
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "2px" }}>
                              <span style={{ fontSize: "14px", fontWeight: "600", color: "#fff" }}>
                                {c.code.toUpperCase()}
                              </span>
                              <span style={{ fontSize: "11px", color: "#8c8c8c" }}>
                                {c.name}
                              </span>
                            </div>
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "bold", fontFamily: "monospace", color: "#fff" }}>
                            {formatBalance(balanceVal, c.code, this.state.activeDbCurrencies)}
                          </span>
                        </DropdownItemButton>
                      );
                    });
                  })()}
                </div>
              </div>
              {/* <div className={"dopdown-menu-right num-style coins-list clist " + walletDropdownStyle} ref={this.walletRef}>
                                <h4>Wallet Options</h4>
                                <ul>
                                    <li>Deposit</li>
                                    <li>Withdraw</li>
                                    <li>Transaction History</li>
                                </ul>
                            </div> */}
            </div>
          </div>
        </li>
        {/* Modal */}
        <StyledModal
          show={this.state.openTransacationModal}
          onHide={this.toggleModalTransaction}
          centered
        >
          <ModalHeader style={{ background: "#17181B" }}>
            <div style={{ fontSize: "16px", fontWeight: "bold" }}>
              Transaction
            </div>
            <X
              onClick={this.toggleModalTransaction}
              size={24}
              style={{ cursor: "pointer" }}
            />
          </ModalHeader>
          <ModalBody style={{ background: "#17181B" }}>
            {/* Pass activeTab to ModalContent */}
            <ModalContent activeTab={this.state.activeTab} />
          </ModalBody>
        </StyledModal>
        <Modal
          size="sm"
          centered={true}
          backdrop={"static"}
          show={this.state.showManage}
          onHide={this.closeManage}
          aria-labelledby="coins-modal"
          className={"animated zoomIn"}
        >
          {/* <Modal.Header className={"font-light"}> */}
          <div
            style={{
              background: "rgb(50 55 56 / calc((100% * 100 / 15) - 50%))",
              padding: "10px",
              borderRadius: "10px 10px 0px 0px",
            }}
          >
            <div
              style={{ color: "#fff", fontWeight: "600", height: "2.5rem" }}
              className="vip2-popup-page"
            >
              <div
                style={{ right: "0", fontSize: "10px", color: "#B3BEC1" }}
                className="vip2-popup-page-btn-in"
                onClick={this.closeManage}
              >
                X
              </div>
              Manage Assets
            </div>
            <div className="serch-bar-main-inner">
              <Search color="#B3BEC1" size={18} />
              <input
                type="text"
                style={{ fontWeight: "600", color: "#B3BEC1" }}
                placeholder="Search coin.. "
                value={searchTerm}
                onChange={this.handleSearch}
                onClick={(e) => e.stopPropagation()}
                onFocus={() =>
                  (this.searchBarDiv.style.border = "1px solid #24EE89")
                } // Add green border
                onBlur={() =>
                  (this.searchBarDiv.style.border = "2px solid transparent")
                } // Remove green border
              />
            </div>
          </div>
          {/* Manage Coins */}
          {/* <button
              type="button"
              className="close p-2"
              onClick={this.closeManage}
            >
              <i className={"mdi mdi-close"} />
            </button> */}
          {/* </Modal.Header> */}
          <Modal.Body className="ccoins p-1">
            {this.state.manage_coins}
          </Modal.Body>
        </Modal>

        <ResponsiveModal
          size="sm"
          centered={true}
          backdrop={"static"}
          show={this.state.showWalletModal}
          onHide={this.toggleWalletModal}
          aria-labelledby="wallet-modal"
          className={"animated zoomIn"}
        >
          {this.state.modalStep === "home" ? (
            <WalletModalHome
              onDeposit={this.onDepositFromHome}
              onWithdraw={this.onWithdrawFromHome}
              onClose={this.toggleWalletModal}
              initialStep={this.state.walletInitialStep || "home"}
              estimatedTotalUsd={
                (this.state.activeDbCurrencies || []).reduce((acc, c) => {
                  const bal = parseFloat(this.state.credits[c.code.toLowerCase()] || 0);
                  const rate = c.code.toLowerCase() === 'inr' ? (this.state.currencyRates?.INR || 100) : 1;
                  return acc + (c.code.toLowerCase() === 'inr' ? bal / rate : bal);
                }, 0).toFixed(2)
              }
              currencies={(this.state.activeDbCurrencies || [])
                .filter(c => parseFloat(this.state.credits[c.code.toLowerCase()] || 0) > 0)
                .map(c => {
                  const code = c.code.toUpperCase();
                  const bal = parseFloat(this.state.credits[c.code.toLowerCase()] || 0);
                  const rate = code === 'INR' ? (this.state.currencyRates?.INR || 100) : 1;
                  const usdVal = code === 'INR' ? bal / rate : bal;
                  return {
                    code: code,
                    name: c.name,
                    color: getCurrencyTheme(c.code).color,
                    symbol: getCurrencyTheme(c.code).glyph,
                    balance: formatBalance(bal, c.code),
                    valueInUsd: usdVal.toFixed(2)
                  };
                })}
              allCurrencies={(this.state.activeDbCurrencies || []).map(c => {
                const code = c.code.toUpperCase();
                const bal = parseFloat(this.state.credits[c.code.toLowerCase()] || 0);
                const rate = code === 'INR' ? (this.state.currencyRates?.INR || 100) : 1;
                const usdVal = code === 'INR' ? bal / rate : bal;
                return {
                  code: code,
                  name: c.name,
                  color: getCurrencyTheme(c.code).color,
                  symbol: getCurrencyTheme(c.code).glyph,
                  balance: bal,
                  formattedBalance: formatBalance(bal, c.code),
                  valueInUsd: usdVal.toFixed(2)
                };
              })}
              currencyRates={this.state.currencyRates}
            />
          ) : (
          <>
          <div>
            {this.state.showCurrencyModal ? (
              <div
                className="button-choose-coin-main"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "15px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    color: "#B3BEC1",
                  }}
                >
                  Choose Coin
                </div>
                <div
                  className="vip2-popup-page-btn-deposit-inner"
                  onClick={this.toggleWalletModal}
                >
                  X
                </div>
              </div>
            ) : (
              <div
                style={{
                  color: "#fff",
                  fontSize: "clamp(14px, 3vw, 18px)",
                  fontWeight: "bold",
                }}
                className="vip2-popup-page-deposit"
              >
                <div
                  className="vip2-popup-page-btn-deposit"
                  onClick={this.toggleWalletModal}
                >
                  X
                  <div
                    style={{
                      fontSize: "16px",
                      textTransform: "capitalize",
                      color: "#616770",
                      cursor: "pointer",
                      marginRight: "10px"
                    }}
                    onClick={() => this.setState({ modalStep: "home" })}
                  >
                    Back
                  </div>
                </div>
                Deposit
              </div>
            )}
          </div>

          <Modal.Body>
            {this.state.showCurrencyModal ? (
              <div>
                <div
                  onClick={(e) => {
                    if (
                      e.target.matches(".search-bar, .search-bar *") ||
                      e.target.matches(".clist, .clist *")
                    ) {
                      return;
                    }
                    this.setState({ show: false });
                  }}
                >
                  <div className="search-bar">
                    <SearchContainer>
                      <Search color="#636A73" size={16} />
                      <input
                        type="text"
                        placeholder="Search coins..."
                        value={searchTerm}
                        onChange={this.handleSearch}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </SearchContainer>
                  </div>
                  <div
                    style={{
                      overflowY: "auto",

                      height: "300px",
                      margin: "15px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      scrollBehavior: "smooth", // Optional for smoother experience
                    }}
                  >
                    {filteredCoinsCurrency}
                  </div>
                  <Divider />
                  <div
                    className="flex justify-between items-center w-full"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginRight: "15px",
                    }}
                  >
                    <ManageListButton onClick={this.manageCoins}>
                      <span>Manage List</span>
                    </ManageListButton>

                    <div className="custom-control custom-switch switch-info mt-2 text-center">
                      <label
                        onClick={(e) => this.usdformat(e)}
                        className="custom-control-label"
                        htmlFor="usdSwitch"
                      >
                        View in USD
                      </label>
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="usdSwitch"
                        checked={this.state.usd}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <NavContainer>
                  <ButtonContainer>
                    {this.sections.map((section) => (
                      <NavButton
                        key={section.id}
                        active={activeSection === section.id}
                        onClick={() => this.setActiveSection(section.id)}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: 1,
                            width: "100%",
                          }}
                        >
                          <section.icon
                            style={{
                              flex: 1,
                              color:
                                activeSection === section.id
                                  ? "white"
                                  : "#8c8c8c", // Change icon color based on active state
                            }}
                            size={16}
                          />
                          <div
                            style={{
                              flex: 1,
                              whiteSpace: "nowrap",
                              fontSize: "clamp(10px, 2vw, 14px)",
                              color:
                                activeSection === section.id
                                  ? "white"
                                  : "#8c8c8c", // Change text color based on active state
                            }}
                          >
                            {section.label}
                          </div>
                        </div>
                      </NavButton>
                    ))}
                  </ButtonContainer>
                </NavContainer>
                {activeSection === "vaultpro" && (
                  <div
                    style={{
                      marginTop: "20px",
                      padding: "0px 20px",
                      marginBottom: "-10px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: "#B3BEC1",
                    }}
                  >
                    <LabelSwap
                      style={{
                        fontWeight: "bold",
                        color: "#B3BEC1 !important",
                      }}
                    >
                      Annual Percentage Rate{" "}
                      <span
                        style={{
                          color: "#43B309",
                          fontWeight: "bold",
                        }}
                      >
                        12%
                      </span>
                    </LabelSwap>
                    <div
                      style={{
                        fontWeight: "bold",
                        color: "#B3BEC1",
                        fontSize: "12px",
                      }}
                    >
                      Security rules
                    </div>
                  </div>
                )}
                <div style={{ marginTop: "12px" }}>
                  <ContentArea>
                    {activeSection === "swap" && (
                      // <div>

                      //     {/* <h1>Current Coin: {selectedCoinSwapSend}</h1>
                      //     <h2>Credit: {creditSWapSend}</h2> */}
                      //     <CoinSelectionModal
                      //         setCoin={this.handleCoinChange}
                      //         setCredit={this.handleCreditChange}
                      //         coin={selectedCoinSwapSend}
                      //         isOpen={this.state.isModalOpenSwapSend}
                      //         onClose={this.closeModal}
                      //     />

                      //     <CoinSelectionModal
                      //         setCoin={this.handleCoinChangeApprox}
                      //         setCredit={this.handleCreditChangeApprox}
                      //         coin={this.state.selectedCoinSwapApprox}
                      //         isOpen={this.state.isModalOpenSwapApprox}
                      //         onClose={this.closeModalApprox}
                      //     />

                      //     <InputContainer>
                      //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      //             <LabelSwap style={{ color: '#B3BEC1 !important' }}>You send</LabelSwap>
                      //             <div>
                      //                 <span style={{ color: '#B3BEC1 !important' }}>Min: 0 </span>
                      //                 <span style={{ color: '#B3BEC1 !important' }}>Balance: {this.state.creditSWapSend} </span>
                      //             </div>
                      //         </div>

                      //         <InputWrapper>
                      //             <Input
                      //                 type="text"
                      //                 name="withdrawAmount"
                      //                 // value={this.state.amount}
                      //                 // onChange={this.handleInputChange}
                      //                 step="0.000000001"
                      //                 min="0"
                      //             />
                      //             <ButtonGroup>

                      //                 <div style={{ backgroundColor: '#3C404B', borderRadius: '22px', padding: '10px 16px', marginRight: '10px' }}>
                      //                     Max
                      //                 </div>

                      //                 <CurrencyInfo style={{ marginRight: '24px' }}>
                      //                     <CurrencyIcon>
                      //                         <img src={'/assets/images/' + __.lowerCase(selectedCoinSwapSend) + '.png'} style={{ height: '32px', width: '32px' }} alt="" />
                      //                     </CurrencyIcon>
                      //                     <CurrencyName>{selectedCoinSwapSend}</CurrencyName>
                      //                 </CurrencyInfo>
                      //                 <ArrowIcon onClick={() => this.setState({ isModalOpenSwapSend: true })}>
                      //                     <ChevronRight />
                      //                 </ArrowIcon>
                      //             </ButtonGroup>
                      //         </InputWrapper>
                      //     </InputContainer>
                      //     {/* <LabelSwap>1 {selectedCoinSwapSend} = {creditSWapSend}{selectedCoinSwapSend}</LabelSwap> */}

                      //     <InputContainer>
                      //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      //             <LabelSwap>You get Approximately</LabelSwap>
                      //             <span style={{ color: '#B3BEC1 !important' }}>Record</span>
                      //         </div>

                      //         <InputWrapper>
                      //             <Input
                      //                 type="text"
                      //                 name="withdrawAmount"
                      //                 // value={this.state.amount}
                      //                 // onChange={this.handleInputChange}
                      //                 step="0.000000001"
                      //                 min="0"
                      //             />
                      //             <ButtonGroup>

                      //                 <div style={{ backgroundColor: '#3C404B', borderRadius: '22px', padding: '10px 16px', marginRight: '10px' }}>
                      //                     Max
                      //                 </div>

                      //                 <CurrencyInfo style={{ marginRight: '24px' }}>
                      //                     <CurrencyIcon>
                      //                         <img src={'/assets/images/' + __.lowerCase(this.state.selectedCoinSwapApprox) + '.png'} style={{ height: '32px', width: '32px' }} alt="" />
                      //                     </CurrencyIcon>
                      //                     <CurrencyName>{this.state.selectedCoinSwapApprox}</CurrencyName>
                      //                 </CurrencyInfo>
                      //                 <ArrowIcon onClick={() => this.setState({ isModalOpenSwapApprox: true })}>
                      //                     <ChevronRight />
                      //                 </ArrowIcon>
                      //             </ButtonGroup>
                      //         </InputWrapper>
                      //     </InputContainer>

                      //     <SubmitContainer>

                      //         <StyledButton>
                      //             Swap
                      //         </StyledButton>
                      //     </SubmitContainer>

                      // </div>
                      <SwapHello />
                    )}
                    {activeSection === "deposit" && (
                      <div>
                        <div style={{ display: "flex", gap: "15px" }}>
                          <div
                            style={{
                              width: "100%",
                              fontSize: "clamp(10px, 3vw, 14px)",
                              whiteSpace: "nowrap",
                              textTransform: "capitalize",
                              color: "#B3BEC1",
                              fontWeight: "bold",
                            }}
                          >
                            {" "}
                            Deposit Currency
                            <CurrencyBox onClick={this.toggleCurrencytModal}>
                              <CurrencyInfo>
                                <CurrencyIcon>
                                  <img
                                    src={
                                      "/assets/images/" +
                                      __.lowerCase(coin) +
                                      ".png"
                                    }
                                    style={{ width: "20px" }}
                                    alt=""
                                  />
                                </CurrencyIcon>
                                <CurrencyName>{coin}</CurrencyName>
                              </CurrencyInfo>

                              <ArrowIcon>
                                <BiChevronDown
                                  style={{
                                    background: "#3a4142",
                                    borderRadius: "5px",
                                    color: "#fff",
                                    fontWeight: "bold",

                                    height: "20px",
                                    width: "20px",
                                  }}
                                />
                              </ArrowIcon>
                            </CurrencyBox>
                          </div>

                          <div
                            style={{
                              width: "100%",
                              fontSize: "clamp(10px, 3vw, 14px)",
                              textTransform: "capitalize",
                              color: "#B3BEC1",
                              fontWeight: "bold",
                            }}
                            onClick={(e) => {
                              this.toggleWalletModal(e);
                              this.setState({ openTransacationModal: true });
                            }}
                          >
                            {" "}
                            balance:
                            <CurrencyBox onClick={this.toggleCurrencytModal}>
                              <BalanceInfo style={{ textAlign: "left" }}>
                                {/* <BalanceLabel>Balance :</BalanceLabel> */}
                                <BalanceAmount>{credit}</BalanceAmount>
                              </BalanceInfo>
                              <ArrowIcon>
                                <BiChevronDown
                                  style={{
                                    background: "#3a4142",
                                    borderRadius: "5px",
                                    color: "#fff",
                                    fontWeight: "bold",

                                    height: "20px",
                                    width: "20px",
                                  }}
                                />
                              </ArrowIcon>
                            </CurrencyBox>
                          </div>
                        </div>

                        <div style={{ marginTop: "10px" }}>
                          <DepositHello coin={coin} />
                        </div>
                      </div>
                    )}
                    {activeSection === "withdraw" && (
                      <div>
                        <div style={{ display: "flex", gap: "15px" }}>
                          <div
                            style={{
                              width: "100%",
                              fontSize: "14px",
                              textTransform: "capitalize",
                              color: "#B3BEC1",
                              fontWeight: "bold",
                            }}
                          >
                            {" "}
                            Withdraw Currency
                            <CurrencyBox onClick={this.toggleCurrencytModal}>
                              <CurrencyInfo style={{ marginRight: "24px" }}>
                                <CurrencyIcon>
                                  <img
                                    src={
                                      "/assets/images/" +
                                      __.lowerCase(coin) +
                                      ".png"
                                    }
                                    style={{ width: "29px" }}
                                    alt=""
                                  />
                                </CurrencyIcon>
                                <CurrencyName>{coin}</CurrencyName>
                              </CurrencyInfo>

                              <ArrowIcon>
                                <BiChevronDown
                                  style={{
                                    background: "#3a4142",
                                    borderRadius: "5px",
                                    color: "#fff",
                                    fontWeight: "bold",

                                    height: "20px",
                                    width: "20px",
                                  }}
                                />
                              </ArrowIcon>
                            </CurrencyBox>
                          </div>

                          <div
                            style={{
                              width: "100%",
                              fontSize: "14px",
                              textTransform: "capitalize",
                              color: "#B3BEC1",
                              fontWeight: "bold",
                            }}
                            onClick={(e) => {
                              this.toggleWalletModal(e);
                              this.setState({ openTransacationModal: true });
                            }}
                          >
                            {" "}
                            balance:
                            <CurrencyBox onClick={this.toggleCurrencytModal}>
                              <BalanceInfo style={{ textAlign: "left" }}>
                                {/* <BalanceLabel>Balance :</BalanceLabel> */}
                                <BalanceAmount>{credit}</BalanceAmount>
                              </BalanceInfo>
                              <ArrowIcon>
                                <BiChevronDown
                                  style={{
                                    background: "#3a4142",
                                    borderRadius: "5px",
                                    color: "#fff",
                                    fontWeight: "bold",

                                    height: "20px",
                                    width: "20px",
                                  }}
                                />
                              </ArrowIcon>
                            </CurrencyBox>
                          </div>
                        </div>
                        <div style={{ marginTop: "22px" }}>
                          <WithdrawlHello coin={coin} />
                        </div>
                      </div>
                    )}

                    {activeSection === "vaultpro" && (
                      <div>
                        <ParentContainer>
                          <SwitcherContainer>
                            <SwitcherButton
                              active={isTransferIn}
                              onClick={this.toggleTransfer}
                            >
                              Transfer In
                            </SwitcherButton>
                            <SwitcherButton
                              active={!isTransferIn}
                              onClick={this.toggleTransfer}
                            >
                              Transfer Out
                            </SwitcherButton>
                          </SwitcherContainer>
                        </ParentContainer>
                        {isTransferIn && (
                          <InputContainer>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <LabelSwap
                                style={{
                                  color: "#B3BEC1",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                Send
                              </LabelSwap>
                              <div style={{ display: "flex", gap: "3px" }}>
                                <div
                                  style={{
                                    color: "#B3BEC1",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Wallet Balance{" "}
                                </div>
                                <div
                                  style={{
                                    color: "#B3BEC1",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {this.state.creditTransferIn}
                                </div>
                              </div>
                            </div>

                            <InputWrapper>
                              <Input
                                type="text"
                                name=" amountTransferIn"
                                value={this.state.amountTransferIn}
                                onChange={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    amountTransferIn: e.target.value,
                                  });
                                }}
                              //   defaultValue="0"
                              />

                              <ButtonGroup>
                                <div
                                  style={{
                                    backgroundColor: "#3C404B",
                                    borderRadius: "22px",
                                    padding: "10px 16px",
                                    marginRight: "10px",
                                  }}
                                >
                                  Max
                                </div>

                                <CurrencyInfo style={{ marginRight: "24px" }}>
                                  <CurrencyIcon>
                                    <img
                                      src={
                                        "/assets/images/" +
                                        __.lowerCase(
                                          this.state.selectedCoinTransferIn
                                        ) +
                                        ".png"
                                      }
                                      style={{ height: "32px", width: "32px" }}
                                      alt=""
                                    />
                                  </CurrencyIcon>
                                  <CurrencyName>
                                    {this.state.selectedCoinTransferIn}
                                  </CurrencyName>
                                </CurrencyInfo>
                                <ArrowIcon onClick={this.openModalTransferIn}>
                                  <ChevronRight />
                                </ArrowIcon>
                              </ButtonGroup>
                            </InputWrapper>
                            <CoinSelectionModal
                              setCoin={this.handleCoinTranserferIn}
                              setCredit={this.handleCreditTransferIn}
                              coin={this.state.selectedCoinTransferIn}
                              isOpen={this.state.isModalOpenTransferIn}
                              onClose={this.closeModalTransferIn}
                            />
                          </InputContainer>
                        )}

                        {!isTransferIn && (
                          <InputContainer>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <LabelSwap
                                style={{
                                  color: "#B3BEC1",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                You Send
                              </LabelSwap>
                              <div>
                                <span
                                  style={{
                                    color: "#B3BEC1",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Vault Balance{" "}
                                </span>
                                <span
                                  style={{
                                    color: "#B3BEC1",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {this.state.vaultAmount}
                                </span>
                              </div>
                            </div>

                            <InputWrapper>
                              <Input
                                type="text"
                                name="amountTransferOut"
                                value={this.state.amountTransferOut}
                                onChange={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    amountTransferOut: e.target.value,
                                  });
                                }}
                              // defaultValue="0"
                              />
                              <ButtonGroup>
                                <div
                                  style={{
                                    backgroundColor: "#3C404B",
                                    borderRadius: "22px",
                                    padding: "10px 16px",
                                    marginRight: "10px",
                                  }}
                                >
                                  Max
                                </div>

                                <CurrencyInfo style={{ marginRight: "24px" }}>
                                  <CurrencyIcon>
                                    <img
                                      src={
                                        "/assets/images/" +
                                        __.lowerCase(
                                          this.state.selectedCoinTransferOut
                                        ) +
                                        ".png"
                                      }
                                      style={{ height: "32px", width: "32px" }}
                                      alt=""
                                    />
                                  </CurrencyIcon>
                                  <CurrencyName>
                                    {this.state.selectedCoinTransferOut}
                                  </CurrencyName>
                                </CurrencyInfo>
                                <ArrowIcon onClick={this.openModalTransferOut}>
                                  <ChevronRight />
                                </ArrowIcon>
                              </ButtonGroup>
                            </InputWrapper>
                            <CoinSelectionModal
                              setCoin={this.handleCoinTranserferOut}
                              setCredit={this.handleCreditTransferOut}
                              coin={this.state.selectedCoinTransferOut}
                              isOpen={this.state.isModalOpenTransferOut}
                              onClose={this.closeModalTransferOut}
                            />
                          </InputContainer>
                        )}

                        <div style={{ color: "red" }}>
                          {this.state.errorSend}
                        </div>

                        <SubmitContainer>
                          <StyledButton onClick={this.handleTransfer}>
                            {isTransferIn
                              ? "Transfer to Vault Pro"
                              : "Withdraw to Wallet"}
                          </StyledButton>
                        </SubmitContainer>
                      </div>
                    )}
                  </ContentArea>
                </div>
              </div>
            )}
          </Modal.Body>
          </>
          )}
        </ResponsiveModal>
        {/* 
                <ResponsiveModal
                    size="sm"
                    centered={true}
                    backdrop={'static'}
                    show={this.state.showCurrencyModal}
                    onHide={this.toggleCurrencytModal}
                    aria-labelledby="wallet-modal"
                    className={"animated zoomIn"}
                >
                    <ModalHeader>
                        <div style={{ fontSize: '16px', textTransform: 'capitalize' }}> Wallet</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: "5px" }}>
                            <div style={{ fontSize: '16px', textTransform: 'capitalize', color: '#616770' }}> Transactions</div>
                            <button type="button" className="close p-2" onClick={this.toggleCurrencytModal}>
                                <i className={'mdi mdi-close'} />
                            </button>
                        </div>

                    </ModalHeader>
                    <Modal.Body>
                        <div>
                           <div>Modal</div>
                        </div>

                    </Modal.Body>
                </ResponsiveModal> */}
      </>
    );
  }
}

Credit.propTypes = {
  setCoin: PropTypes.func.isRequired,
  coin: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
});

const ConnectedCredit = connect(mapStateToProps, { setCoin, gameCoin, setCredit })(Credit);

export function CreditWrapper(props) {
  const transferVaultLocalMutation = useTransferVaultLocalMutation();
  const getVaultDataLocalMutation = useGetVaultDataLocalMutation();

  return (
    <ConnectedCredit 
      {...props} 
      transferVaultLocal={transferVaultLocalMutation.mutateAsync}
      getVaultDataLocal={getVaultDataLocalMutation.mutateAsync}
    />
  );
}

export default CreditWrapper;
